"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IModelInfoBaseSchema = void 0;
const zod_1 = require("zod");
const IModelInfoBaseSchema = (tSignalMapSchema) => zod_1.z.object({
    signalConnectionMap: tSignalMapSchema
        .array()
        .describe('The map of sub model signals to component signals, modes, and internal nets.'),
    parameterMap: zod_1.z.any().optional().describe('The map of sub model parameters to component values'),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional().describe('Arbitrary optional metadata describing this model'),
});
exports.IModelInfoBaseSchema = IModelInfoBaseSchema;
//# sourceMappingURL=IModelInfoBase.js.map